import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFastlyComponent } from './simple-icons-fastly.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFastlyComponent ],
    exports:      [ SimpleIconsFastlyComponent ],
    bootstrap:    []
})
export class SimpleIconsFastlyModule {}
